import React from 'react'
import styled from 'styled-components'

import { ease } from '../globalStyles'
import { Absolute } from './common'
import Spinner from './Spinner'

const BackgroundImage = styled(Absolute).attrs({
  className: 'BackgroundImage'
})`
  background-size: cover;
  background-position: center;
  background-image: url(${props => props.image});
  opacity: ${props => props.opacity || 1};
  transition: opacity 0.5s ${ease.popIn};

  .Spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
  }
`
export default ({ noSpinner = false, className = '', ...props }) => (
  <BackgroundImage className={`BackgroundImage ${className}`} {...props}>
    {!noSpinner && <Spinner />}
  </BackgroundImage>
)



// WEBPACK FOOTER //
// ./src/components/BackgroundImage.js